/* Dawn 15.x — Variant VIDEO filtering using product JSON + ALT/FILENAME key
   Assumes your color token is at position 3 when splitting on '-'
   (e.g., Cosy-Charlotte-MidnightNavy-Video1)
*/
(() => {
  const DELIMITER = "-";
  const POSITION = 3; // 1-indexed (Cosy=1, Charlotte=2, MidnightNavy=3)

  // helpers
  const norm = s => (s || "").toString().toLowerCase().replace(/\s+/g, "");
  const q = (sel, root=document) => root.querySelector(sel);
  const qa = (sel, root=document) => Array.from(root.querySelectorAll(sel));

  // find product JSON (Dawn puts it on the page)
  function getProductJSON() {
    const el = q("script[type='application/json'][data-product]");
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch { return null; }
  }

  // current variant (by the hidden id input)
  function getCurrentVariant(product) {
    const idInput = q('input[name="id"]');
    const id = idInput && idInput.value;
    if (!id || !product?.variants) return null;
    return product.variants.find(v => String(v.id) === String(id)) || null;
  }

  // derive selected color from variant and product option names
  function getSelectedColor(product, variant) {
    if (!product || !variant) return "";
    // Find which option is Color/Colour (first try explicit name)
    let colorIndex = product.options.findIndex(o =>
      /colou?r/i.test(o)
    );
    // fallback to first option
    if (colorIndex === -1) colorIndex = 0;
    const value = variant[`option${colorIndex + 1}`];
    return value || "";
  }

  // Build a map: media.id -> key extracted from media.alt or preview image filename
  function buildMediaKeyMap(product) {
    const map = new Map();
    const media = product?.media || [];
    media.forEach(m => {
      let sourceStr =
        m.alt ||
        (m.preview_image && (m.preview_image.alt || m.preview_image.src)) ||
        m.src ||
        "";

      sourceStr = sourceStr.split("?")[0];
      const filename = sourceStr.split("/").pop().replace(/\.[^./]+$/, "");
      const parts = filename.split(DELIMITER);
      const key = parts[POSITION - 1] || "";
      map.set(String(m.id), norm(key));
    });
    return map;
  }

  function hideShowVideos(product, mediaKeyMap) {
    const variant = getCurrentVariant(product);
    const selectedColor = norm(getSelectedColor(product, variant));
    if (!selectedColor) return;

    // Only touch VIDEO media wrappers
    qa("media-gallery [data-media-id]").forEach(wrapper => {
      const mediaId = wrapper.getAttribute("data-media-id");
      const type = wrapper.getAttribute("data-media-type") || wrapper.dataset.mediaType || "";
      if (!/video/i.test(type)) return; // ignore images/models

      const key = mediaKeyMap.get(String(mediaId)) || "";
      const isGlobal = !key;
      const shouldShow = isGlobal || key === selectedColor;

      wrapper.toggleAttribute("hidden", !shouldShow);
      wrapper.style.display = shouldShow ? "" : "none";
      wrapper.setAttribute("aria-hidden", shouldShow ? "false" : "true");
    });
  }

  function wire(product, mediaKeyMap) {
    // respond to any variant change
    const handlers = () => hideShowVideos(product, mediaKeyMap);

    // radios/selects
    qa('variant-selects select, variant-radios input[name^="options"]').forEach(el =>
      el.addEventListener("change", handlers)
    );
    // hidden id (some apps update only this)
    const idInput = q('input[name="id"]');
    if (idInput) idInput.addEventListener("change", handlers);

    // common custom events
    ["variant:change","product:variant-change","form:variant:change","form:variant:changed"]
      .forEach(evt => document.addEventListener(evt, handlers));

    // initial run
    handlers();
  }

  function init() {
    if (!q("media-gallery")) return;
    const product = getProductJSON();
    if (!product) return;
    const mediaKeyMap = buildMediaKeyMap(product);
    wire(product, mediaKeyMap);
  }

  document.addEventListener("DOMContentLoaded", init);
  document.addEventListener("shopify:section:load", init);
})();
